var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dropdown-select',{attrs:{"options":_vm.getComputedOptions(),"current-option":_vm.currentOption,"default-option":{ value: 0, name: _vm.__('Wszystkie hufce') },"icon":"fas fa-flag"},on:{"change":_vm.onDistrictChange}})}
var staticRenderFns = []

export { render, staticRenderFns }